import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getFile,
  getFileBlob,
  getRDM,
  getVehicleInformation,
  getVehicleInformationDownload,
  getVehicleInformationDownloadBlob,
  updateRDM,
  getUniqueVehicleList,
  getSingleVehicleInformation,
  getTransactionLogs
} from "./transactionLogAPI";

const initialState = {
  data: null,
  data2: [],
  data3: [],
  savedVehicleList: [],
  vehicleList: [],
  vehicleDetail: [],
  transactionLogList: [],
  logPageNo: 1,
  logPageSize: 10,
  logTotalRecord: 0,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  dataId: null,
};

export const fetchReporting = createAsyncThunk(
  "transactionLog/fetchReporting",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchUniqueVehicleList = createAsyncThunk(
  "transactionLog/fetchUniqueVehicleList",
  async (payload) => {
    const response = await getUniqueVehicleList(payload);
    return response;
  }
);

export const fetchReportingVehicleInfo = createAsyncThunk(
  "transactionLog/fetchReportingVehicleInfo",
  async (payload) => {
    const response = await getVehicleInformation(payload);
    return response;
  }
);

export const fetchSingleVehicleInfo = createAsyncThunk(
  "transactionLog/fetchSingleVehicleInfo",
  async (payload) => {
    const response = await getSingleVehicleInformation(payload);
    return response;
  }
);

export const fetchTransactionLogs = createAsyncThunk(
  "transactionLog/fetchTransactionLogs",
  async ({vehicle_id, payload}) => {
    const response = await getTransactionLogs(vehicle_id, payload);
    return response;
  }
);

export const fetchReportingVehicleInfoDownload = createAsyncThunk(
  "transactionLog/fetchReportingVehicleInfoDownload",
  async (payload) => {
    const response = await getVehicleInformationDownload(payload);
    return response;
  }
);

export const fetchReportingVehicleInfoDownloadBlob = createAsyncThunk(
  "transactionLog/fetchReportingVehicleInfoDownloadBlob",
  async (payload) => {
    const response = await getVehicleInformationDownloadBlob(payload);
    return response;
  }
);

export const editRdm = createAsyncThunk(
  "transactionLog/updateRdm",
  async (payload) => {
    const response = await updateRDM(payload);
    return response;
  }
);
export const fetchRdm = createAsyncThunk(
  "transactionLog/fetchRdm",
  async (payload) => {
    const response = await getRDM(payload);
    return response;
  }
);
export const fetchFile = createAsyncThunk(
  "transactionLog/fetchFile",
  async (payload) => {
    const response = await getFile(payload);
    return response;
  }
);
export const fetchFileBlob = createAsyncThunk(
  "transactionLog/fetchFileBlob",
  async (payload) => {
    const response = await getFileBlob(payload);
    return response;
  }
);

export const transactionLogSlice = createSlice({
  name: "transactionLog",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    saveVehicleList: (state, action) => {
      state.savedVehicleList = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReporting.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReporting.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchUniqueVehicleList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUniqueVehicleList.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleList = action.payload.data.data;
      })
      .addCase(fetchSingleVehicleInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSingleVehicleInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleDetail = action.payload.data.data;
      })
      .addCase(fetchTransactionLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTransactionLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.transactionLogList = action.payload.data.data;
        state.logPageNo = action.payload.data.pageNo;
        state.logPageSize = action.payload.data.pageSize;
        state.logTotalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchReportingVehicleInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReportingVehicleInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.data3 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchRdm.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRdm.fulfilled, (state, action) => {
        state.loading = false;
        state.data2 = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchReportingVehicleInfoDownload.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReportingVehicleInfoDownload.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchReportingVehicleInfoDownloadBlob.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchReportingVehicleInfoDownloadBlob.fulfilled,
        (state, action) => {
          state.loading = false;
          state.result = action.payload;
        }
      )
      .addCase(fetchFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFile.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchFileBlob.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFileBlob.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editRdm.pending, (state) => {
        state.loading = true;
      })
      .addCase(editRdm.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected, saveVehicleList } = transactionLogSlice.actions;

export const selectSavedVehicleList = (state) => state.transactionLog.savedVehicleList;
export const selectVehicleList = (state) => state.transactionLog.vehicleList;
export const selectVehicleDetail = (state) => state.transactionLog.vehicleDetail;
export const selectReporting = (state) => state.transactionLog.data;
export const selectReporting2 = (state) => state.transactionLog.data3;
export const selectManager = (state) => state.transactionLog.data2;
export const selectLoading = (state) => state.transactionLog.loading;
export const selectError = (state) => state.transactionLog.error;
export const selectPageNo = (state) => state.transactionLog.pageNo;
export const selectPageSize = (state) => state.transactionLog.pageSize;
export const selectTotalRecord = (state) => state.transactionLog.totalRecord;
export const selectSelected = (state) => state.transactionLog.selected;
export const selectResult = (state) => state.transactionLog.result;
export const selectTransactionLogList = (state) => state.transactionLog.transactionLogList;
export const selectLogPageNo = (state) => state.transactionLog.logPageNo;
export const selectLogPageSize = (state) => state.transactionLog.logPageSize;
export const selectLogTotalRecord = (state) => state.transactionLog.logTotalRecord;

export default transactionLogSlice.reducer;
